import { create } from "zustand";

const stencilStore = create((set) => ({
  stencils: [],

  setStencils: (data) => set({ stencils: data }),

  reset: () => {
    set({ stencils: [] });
  },
}));

export default stencilStore;
